module.exports = __webpack_public_path__ + "img/Hypoxia-LICA_PLC.7efc0876.png";